import { smoothHolterSamples } from 'utils/ecg-utils';
import { createComparedXML } from './create-compared-xml.helper';
import { downloadXmlHelper } from './download-xml.helper';
import { removeDCBias } from 'utils/util';

type Payload = {
  intEverbeatSamples: number[];
  referenceIndex: number;
  everbeatIndex: number;
  intReferenceSamples?: number[];
  referenceSampleRate?: number;
  isFullSamples?: boolean;
};

const downloadAnalysisXml = ({
  intEverbeatSamples,
  intReferenceSamples,
  referenceIndex,
  everbeatIndex,
  referenceSampleRate = 512,
  isFullSamples = false,
}: Payload) => {
  const dibiasedEverbeat = removeDCBias(intEverbeatSamples);
  const everbeatXml = createComparedXML(dibiasedEverbeat);
  const postfix = isFullSamples ? '-full-samples' : '';
  if (intReferenceSamples) {
    const filteredReference = smoothHolterSamples(intReferenceSamples, referenceSampleRate);
    const referenceXml = createComparedXML(filteredReference);
    downloadXmlHelper(referenceXml, `${referenceIndex}${postfix}.xml`);
  }

  downloadXmlHelper(everbeatXml, `${everbeatIndex}${postfix}.xml`);
};

export { downloadAnalysisXml };
